import { useNavigate } from '@tanstack/react-router';

import { ContractMessage, ContractState } from '../../../../../types/ContractMessage';
import { VesselMessage } from '../../../../../types/VesselMessage';
import { DropdownMenu, DropdownMenuOption } from '../../../../cdl/DropdownMenu/DropdownMenu';
import { IconButton } from '../../../../cdl/IconButton/IconButton';
import { translate } from '../../../../common/helpers/translate.helper';
import { IconDots } from '../../../../common/icons/cdl/Dots';

interface VesselContractRowActionsMenuProps {
    contract: ContractMessage;
    vessel: VesselMessage;
    onClearDefault: (contract: ContractMessage) => void;
    onSetDefault: (contract: ContractMessage) => void;
    onExclude: (contract: ContractMessage) => void;
}

export const VesselContractRowActionsMenu = ({
    contract,
    vessel,
    onClearDefault,
    onSetDefault,
    onExclude,
}: VesselContractRowActionsMenuProps) => {
    const navigate = useNavigate();
    const isDefaultContract = contract.id === vessel.defaultContractId;
    const canSetDefaultContract = contract.state === ContractState.ACTIVE;

    const options: DropdownMenuOption[] = [
        {
            label: translate('vessel.contracts.actions.viewContractDetails'),
            onSelect: () =>
                navigate({
                    to: '/contracts/$id',
                    params: { id: contract.id },
                    state: { vesselId: vessel.id },
                }),
        },
    ];

    if (isDefaultContract) {
        options.push({
            label: translate('vessel.contracts.actions.clearDefaultContract'),
            onSelect: () => onClearDefault(contract),
        });
    } else if (canSetDefaultContract) {
        options.push({
            label: translate('vessel.contracts.actions.setDefaultContract'),
            onSelect: () => onSetDefault(contract),
        });
    }

    options.push({
        label: translate('vessel.contracts.actions.excludeVesselFromContract'),
        onSelect: () => onExclude(contract),
    });

    return <DropdownMenu align="end" trigger={<IconButton Icon={IconDots} />} options={options} />;
};
